export default "__VITE_ASSET__CetDQy0Q__"